import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * AspectRatioIndicator Component
 * Badge indicator shown when image is in Canvas Mode (non-9:16 aspect ratio)
 * Displays in top-left corner of preview to inform user
 */
export const AspectRatioIndicator = ({ visible }) => {
  const { t } = useTranslation('approval');

  if (!visible) return null;

  return (
    <div className="absolute top-2 left-2 z-20">
      <div className="bg-amber-100 text-amber-800 px-3 py-1.5 rounded-full text-xs font-medium border border-amber-300 shadow-sm flex items-center gap-1.5 backdrop-blur-sm">
        {/* Aspect Ratio Icon */}
        <svg
          className="w-3.5 h-3.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
          />
        </svg>
        <span>
          {t('aspectRatioIndicator.label', { defaultValue: 'Canvas Mode' })}
        </span>
      </div>
    </div>
  );
};

AspectRatioIndicator.propTypes = {
  visible: PropTypes.bool.isRequired
};

export default AspectRatioIndicator;
